import { Outlet } from "react-router-dom"
import React, {useEffect} from 'react'
import { ToastContainer } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css'
import { animateScroll as scroll } from 'react-scroll'




const Layout = () => {

  useEffect(() => {
    scroll.scrollToTop();
  }, []);
  
  
    return (
        <div className='mx-auto flex h-[100dvh] flex-col overflow-y-scroll bg-[#041F33]' style={{backgroundImage: 'radial-gradient(circle at top, rgba(23,57,90,0.72) 0%, rgba(16,45,71,0.35) 36%, rgba(4,31,51,0) 72%)'}}>
            <ToastContainer />
            <Outlet />
        </div>
  )
}

export default Layout
